/* eslint-disable */
import { useParams, useNavigate } from "react-router-dom";
import {
  Row,
  Container,
  Col,
  Form,
  Tab,
  Tabs,
  Toast,
  ToastContainer,
  Spinner,
} from "react-bootstrap";

import { Button } from "react-bootstrap";
import { useEffect, useState, Fragment, useRef } from "react";

import Collapse from "react-bootstrap/Collapse";

import "./Viewer.css";

import TabbedViewer from "./TabbedViewer";
import ChronoViewer from "./ChronoViewer";

import { FaPen, FaSkull } from "react-icons/fa6";
import { FaFastForward, FaUndo, FaArchive, FaMeteor } from "react-icons/fa";

import SinglePane from "./SinglePane";
import { buildSlackChannelUrl } from "../../constants/slackConstants";
import { VersionHistoryAPI } from "../../connections/VersionHistory";
import VersionHistory from "../VersionHistory/VersionHistory";
// Generated by GitHub Copilot
import { ConfigurationAPI } from "../../connections/Configuration";
// Generated by GitHub Copilot
import { useFeatureToggle } from "../../hooks/useFeatureToggle";
// Generated by GitHub Copilot
import {
  trackProblemView,
  trackUniqueVisitor,
  initializeEngagementTracking,
} from "../../utils/newrelicTracking";

// Generated by GitHub Copilot
import LeftNavigation from "../LeftNavigation/LeftNavigation";
// Generated by GitHub Copilot - Impact reporting modal
import ImpactFormModal from "../Impact/ImpactFormModal";
import { impactService } from "../../services/impactService";
import { LightModeLayout } from "../Layout/LightModeLayout";
// US2097708: shared promoted-away forward predicate (also used by ProblemForm.js).
import { shouldForwardToPermanent } from "../../utils/incidentLinkage";

const dayjs = require("dayjs");
const relativeTime = require("dayjs/plugin/relativeTime");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

function capitalizeEverything(string) {
  return string ? string.toUpperCase() : "";
}

function Viewer(props) {
  let params = useParams();
  const navigate = useNavigate();
  const { configuration: appConfiguration, user } = props;
  // Generated by GitHub Copilot
  // State for feature toggle
  const [showRevisions, setShowRevisions] = useState(false);

  // Generated by GitHub Copilot
  // Use feature toggle hook for onepagesummary feature
  const { isEnabled: useOnePageSummary, isLoading: featureLoading } =
    useFeatureToggle("onepagesummary", props.user);

  // Feature toggle hook for chronological timeline view
  const { isEnabled: useChronoView, isLoading: chronoLoading } =
    useFeatureToggle("chronological", props.user);

  // Generated by GitHub Copilot
  // Track viewport width to force single pane on mobile devices
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  // Generated by GitHub Copilot - Reduced from 90s to 10s for faster updates
  const highRatePolling = 10 * 1000;

  // Generated by GitHub Copilot
  // Construct the problem URL - use version endpoint if versionId is present
  const problemURL = params.versionId
    ? `/api/v1/problem/${params.id}/version/${params.versionId}?mode=viewer`
    : `/api/v1/problem/${params.id}?mode=viewer`;

  const [error, setError] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [problem, setProblem] = useState();
  const [outage, setOutage] = useState({
    number: 0,
    description: "No Description",
  });

  const [impactedApps, setImpactedApps] = useState([]);
  const [currentTime, setCurrentTime] = useState({});
  const [slackURL, setSlackURL] = useState();

  const [timeline, setTimeline] = useState();

  const [polling, setPolling] = useState(true);
  const [pollingInterval, setPollingInterval] = useState(highRatePolling);

  const [notes, setNotes] = useState([]);

  const [archived, setArchived] = useState(false);

  const [editMode, setEditMode] = useState(true);

  const [permanent, setPermanent] = useState("");

  const [priorityDescription, setPriorityDescription] = useState("");

  // Generated by GitHub Copilot - Track if we're viewing a historical version
  const [isHistoricalVersion, setIsHistoricalVersion] = useState(false);

  // Generated by GitHub Copilot - Track version timestamp for historical versions
  const [versionTimestamp, setVersionTimestamp] = useState(null);

  // Generated by GitHub Copilot - NewRelic engagement tracking cleanup function
  const [engagementTracker, setEngagementTracker] = useState(null);

  // Generated by GitHub Copilot - Track restore process
  const [restoring, setRestoring] = useState(false);

  // Generated by GitHub Copilot - Track archive process
  const [archiving, setArchiving] = useState(false);

  // Generated by GitHub Copilot - Prevent rapid double-clicks
  const [lastArchiveAttempt, setLastArchiveAttempt] = useState(0);

  // Generated by GitHub Copilot - Toast notifications for user feedback
  const [toasts, setToasts] = useState([]);

  // Generated by GitHub Copilot - Impact report modal state
  const [showImpactModal, setShowImpactModal] = useState(false);
  const [submittingImpact, setSubmittingImpact] = useState(false);
  // Generated by GitHub Copilot - Trigger to refresh impact list after creating new impact
  const [impactRefreshTrigger, setImpactRefreshTrigger] = useState(0);

  // Generated by GitHub Copilot - Track last patch timestamp for incremental polling
  // Use useRef so the interval closure always has the latest value
  const lastPatchTimestampRef = useRef(Date.now());

  // Generated by GitHub Copilot - Update outage state when problem changes (for patch updates)
  useEffect(() => {
    if (problem && problem.outages && problem.outages["OUTAGE 1"]) {
      const currentOutage = problem.outages["OUTAGE 1"];
      const timeFormat = "MM-DD-YYYY hh:mm A z";

      // Format timestamps before setting state so patch poll updates
      // don't overwrite formatted values with raw epoch numbers (US1905106)
      const formattedOutage = {
        ...currentOutage,
        incidentStart: currentOutage.incidentStart ? dayjs(Number(currentOutage.incidentStart) || 0).format(timeFormat) : "",
        incidentEnd: currentOutage.incidentEnd ? dayjs(Number(currentOutage.incidentEnd) || 0).format(timeFormat) : "",
        eocNotified: currentOutage.eocNotified ? dayjs(Number(currentOutage.eocNotified) || 0).format(timeFormat) : "",
        timeDetected: currentOutage.timeDetected ? dayjs(Number(currentOutage.timeDetected) || 0).format(timeFormat) : "",
        techTimeResolved: currentOutage.techTimeResolved ? dayjs(Number(currentOutage.techTimeResolved) || 0).format(timeFormat) : "",
        nextUpdate: currentOutage.nextUpdate > 0 ? dayjs(Number(currentOutage.nextUpdate)).format(timeFormat) : "As more information becomes available",
        incidentStartRaw: Number(currentOutage.incidentStart) || null,
        incidentEndRaw: Number(currentOutage.incidentEnd) || null,
      };

      if (currentOutage.description) {
        const splitLines = currentOutage.description.split("\n");
        formattedOutage.currentStatus = splitLines.map((d) => {
          const key = Math.random();
          return <p key={key}>{d}</p>;
        });
      }

      setOutage(formattedOutage);
      setPriorityDescription(priorityDescriptionMap[currentOutage.priority]);
    }
  }, [problem]);

  // Generated by GitHub Copilot - Auto-redirect to permanent problem number
  // US2097708: forward only WHILE the record is still temporary, which matches AC5 as
  // corrected in Rally on 2026-08-31. (The AC previously read the opposite; that is
  // history, not a current divergence — do not flip the polarity.) The reasoning lives
  // with the predicate in utils/incidentLinkage.js (shouldForwardToPermanent), which the
  // edit page's load-time forward shares so the two forwards can never diverge.
  useEffect(() => {
    if (shouldForwardToPermanent(permanent, problem)) {
      navigate(`/problem/view/${permanent}`);
    }
  }, [permanent, problem, navigate]);

  const clearError = () => {
    setError();
  };

  // Generated by GitHub Copilot - Fetch and apply patches incrementally
  const fetchAndApplyPatches = async () => {
    if (!params.id || params.versionId || archived) {
      return; // Don't poll patches for historical versions or archived problems
    }

    try {
      const url = `/api/v1/problems/${params.id}/patches?since=${lastPatchTimestampRef.current}`;
      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) {
        console.warn(`[Viewer] Failed to fetch patches: ${response.status}`);
        return;
      }

      const data = await response.json();
      const patches = data.patches || [];

      // Update timestamp to current time so next poll starts from now
      const currentTimestamp = Date.now();
      lastPatchTimestampRef.current = currentTimestamp;

      if (patches.length === 0) {
        return; // No new patches
      }

      // Apply patches to problem state
      setProblem((currentProblem) => {
        if (!currentProblem) {
          console.warn("[Viewer] No current problem to apply patches to");
          return currentProblem;
        }

        let updated = { ...currentProblem };

        patches.forEach((patch) => {
          const { fieldPath, newValue } = patch;

          // Temporary debug logging for pagerduty_id
          if (fieldPath.includes("pagerduty")) {
            console.log(
              `[Viewer DEBUG] Applying patch: fieldPath="${fieldPath}", newValue="${newValue}"`
            );
          }

          // Check if this is an outage field (needs to be applied to first outage)
          // The backend stores simplified paths like "status", "priority", etc.
          // We need to apply these to the first outage
          const outageFields = [
            "priority",
            "status",
            "description",
            "short_description",
            "impact",
            "workaround",
            "commander",
            "slack_channel",
            "mim",
            "MIM",
            "business_liaison",
            "message_for_clients",
            "pagerduty_id",
            "technical_status",
            "perceived_cause",
            "current_approach",
            "vendor_ticket",
            "end_user_experience",
            "affected_users",
            "number_of_contacts",
            "salesforce_case",
            "aws_account",
            "aws_case",
            "attendees",
            "incident_start",
            "incident_end",
            "time_detected",
            "eoc_notified",
            "tech_time_resolved",
            "next_update",
            "impacted_applications",
            "affected_brands",
          ];

          // Simple field path handling for outage fields
          if (fieldPath.startsWith("outages.")) {
            const parts = fieldPath.split(".");
            if (parts.length === 3) {
              const outageId = parts[1];
              const field = parts[2];

              // Map backend field names to frontend property names
              const fieldMap = {
                commander: "incidentCommander",
                slack_channel: "slackChannel",
                // Note: mim stays as "mim" - no mapping needed
                business_liaison: "businessLiaison",
                message_for_clients: "messageForClients",
                pagerduty_id: "pagerDutyID",
                technical_status: "technicalStatus",
                perceived_cause: "perceivedCause",
                current_approach: "currentApproach",
                vendor_ticket: "vendorTicket",
                end_user_experience: "endUserExperience",
                affected_users: "affectedUsers",
                number_of_contacts: "numberOfContacts",
                salesforce_case: "salesForceCase",
                aws_account: "awsAccount",
                aws_case: "awscase",
                incident_start: "incidentStart",
                incident_end: "incidentEnd",
                time_detected: "timeDetected",
                eoc_notified: "eocNotified",
                tech_time_resolved: "techTimeResolved",
                next_update: "nextUpdate",
                impacted_applications: "impactedApplications",
                affected_brands: "affectedBrandCapability",
              };
              const actualField = fieldMap[field] || field;

              if (updated.outages && updated.outages[outageId]) {
                updated = {
                  ...updated,
                  outages: {
                    ...updated.outages,
                    [outageId]: {
                      ...updated.outages[outageId],
                      [actualField]: newValue,
                    },
                  },
                };
              } else {
                console.warn(
                  `[Viewer] Outage ${outageId} not found in problem`
                );
              }
            }
          } else if (outageFields.includes(fieldPath)) {
            // Simplified outage field path - apply to first outage
            const firstOutageId = updated.outages
              ? Object.keys(updated.outages)[0]
              : null;

            if (firstOutageId) {
              // Map backend field names to frontend property names
              const fieldMap = {
                commander: "incidentCommander",
                slack_channel: "slackChannel",
                // Note: mim stays as "mim" - no mapping needed
                business_liaison: "businessLiaison",
                message_for_clients: "messageForClients",
                pagerduty_id: "pagerDutyID",
                technical_status: "technicalStatus",
                perceived_cause: "perceivedCause",
                current_approach: "currentApproach",
                vendor_ticket: "vendorTicket",
                end_user_experience: "endUserExperience",
                affected_users: "affectedUsers",
                number_of_contacts: "numberOfContacts",
                salesforce_case: "salesForceCase",
                aws_account: "awsAccount",
                aws_case: "awscase",
                incident_start: "incidentStart",
                incident_end: "incidentEnd",
                time_detected: "timeDetected",
                eoc_notified: "eocNotified",
                tech_time_resolved: "techTimeResolved",
                next_update: "nextUpdate",
                impacted_applications: "impactedApplications",
                affected_brands: "affectedBrandCapability",
              };
              const actualField = fieldMap[fieldPath] || fieldPath;

              // Temporary debug logging for pagerduty_id
              if (fieldPath.includes("pagerduty")) {
                console.log(
                  `[Viewer DEBUG] Mapped fieldPath="${fieldPath}" to actualField="${actualField}" for outage ${firstOutageId}`
                );
                console.log(
                  `[Viewer DEBUG] Setting ${actualField} = "${newValue}"`
                );
              }

              updated = {
                ...updated,
                outages: {
                  ...updated.outages,
                  [firstOutageId]: {
                    ...updated.outages[firstOutageId],
                    [actualField]: newValue,
                  },
                },
              };
            } else {
              console.warn(`[Viewer] No outages found in problem`);
            }
          } else {
            // Problem-level field
            updated = {
              ...updated,
              [fieldPath]: newValue,
            };
          }
        });

        return updated;
      });
    } catch (err) {
      console.error("[Viewer] Failed to fetch/apply patches:", err);
    }
  };

  // Generated by GitHub Copilot
  // Report interest - automatically register user as interested party when viewing problem
  const reportInterest = async () => {
    if (!params.id || !props.user || !props.user.email) {
      return;
    }

    try {
      const response = await fetch(`/api/v1/problem/${params.id}/parties`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: props.user.email,
          name: props.user.name || props.user.email, // Include name, fallback to email if name not available
        }),
      });

      if (!response.ok) {
        console.warn(`Failed to register interested party: ${response.status}`);
      }
      // Silently handle success - no need to notify user of automatic registration
    } catch (error) {
      console.warn("Failed to register interested party:", error);
      // Fail silently - this is a background enhancement, not critical functionality
    }
  };

  // Generated by GitHub Copilot
  // Remove a toast by ID
  const removeToast = (toastId) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== toastId));
  };

  // Generated by GitHub Copilot
  // Open impact report modal
  const handleOpenImpactModal = () => {
    setShowImpactModal(true);
  };

  // Generated by GitHub Copilot
  // Submit impact report
  const handleSubmitImpact = async (formData) => {
    setSubmittingImpact(true);
    try {
      await impactService.createImpact(params.id, formData);

      // Show success toast
      setToasts((prev) => [
        ...prev,
        {
          id: Date.now(),
          type: "success",
          title: "Impact Reported",
          message: "Your impact report has been submitted successfully",
        },
      ]);

      // Close modal
      setShowImpactModal(false);

      // Generated by GitHub Copilot - Trigger impact list refresh
      setImpactRefreshTrigger((prev) => prev + 1);
    } catch (err) {
      console.error("Failed to submit impact:", err);

      // Show error toast
      setToasts((prev) => [
        ...prev,
        {
          id: Date.now(),
          type: "error",
          title: "Submission Failed",
          message: err.message || "Failed to submit impact report. Please try again.",
        },
      ]);
    } finally {
      setSubmittingImpact(false);
    }
  };

  // Generated by GitHub Copilot
  // Handle restoring a historical version
  const handleRestoreVersion = async () => {
    if (!params.versionId || !params.id) {
      return;
    }

    if (
      !window.confirm(
        `Are you sure you want to restore this version? This will replace the current version and redirect you to the latest version.`
      )
    ) {
      return;
    }

    setRestoring(true);
    setError("");

    try {
      const response = await VersionHistoryAPI.restoreVersion(
        params.id,
        params.versionId
      );
      if (response.success) {
        // Redirect to the latest version after successful restore
        navigate(`/problem/view/${params.id}`);
      } else {
        setError(`Failed to restore version: ${response.error}`);
      }
    } catch (err) {
      setError(`Failed to restore version: ${err.message}`);
    } finally {
      setRestoring(false);
    }
  };

  // Generated by GitHub Copilot
  // Handle archiving a problem
  const handleArchiveProblem = async () => {
    if (!params.id) {
      return;
    }

    // Prevent rapid double-clicks (debounce with 2 second window)
    const now = Date.now();
    if (now - lastArchiveAttempt < 2000) {
      return;
    }
    setLastArchiveAttempt(now);

    // Pre-archive validation
    if (
      !props.user ||
      !props.user.privileges ||
      !props.user.privileges.archive
    ) {
      setToasts((prev) => [
        ...prev,
        {
          id: Date.now(),
          type: "error",
          title: "Access Denied",
          message:
            "You don't have permission to archive problems. Your privileges may have changed.",
        },
      ]);
      return;
    }

    if (archived) {
      setToasts((prev) => [
        ...prev,
        {
          id: Date.now(),
          type: "warning",
          title: "Already Archived",
          message: "This problem has already been archived.",
        },
      ]);
      return;
    }

    const problemTitle = problem?.title || "Unknown Problem";
    const problemNumber = problem?.number || params.id;

    if (
      !window.confirm(
        `Are you sure you want to archive this problem?\n\nProblem: ${problemNumber}\nTitle: ${problemTitle}\n\nThis action cannot be undone.`
      )
    ) {
      return;
    }

    setArchiving(true);
    setError("");

    // Show loading toast
    const loadingToastId = Date.now();
    setToasts((prev) => [
      ...prev,
      {
        id: loadingToastId,
        type: "info",
        title: "Archiving Problem",
        message: "Processing your request...",
      },
    ]);

    try {
      const response = await fetch(`/api/v1/problem/${params.id}/archive`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Remove loading toast
      removeToast(loadingToastId);

      if (response.ok) {
        // Update local state to immediately reflect archived status
        setArchived(true);

        // Show success toast with problem details
        const problemTitle = problem?.title || "Unknown Problem";
        const problemNumber = problem?.number || params.id;

        setToasts((prev) => [
          ...prev,
          {
            id: Date.now(),
            type: "success",
            title: "Problem Archived",
            message: `Problem ${problemNumber}: "${problemTitle}" has been successfully archived`,
          },
        ]);

        // Redirect to problem list after brief delay to show success message
        setTimeout(() => {
          navigate("/problems");
        }, 1500);
      } else {
        const errorData = await response.text();
        let errorMessage;
        let errorTitle;

        // Handle specific HTTP status codes
        if (response.status === 401) {
          errorTitle = "Session Expired";
          errorMessage =
            "Your session has expired. Please refresh the page and try again.";
        } else if (response.status === 403) {
          errorTitle = "Access Denied";
          errorMessage =
            "You no longer have permission to archive problems. Your privileges may have changed.";
        } else {
          errorTitle = "Archive Failed";
          errorMessage = `Failed to archive problem: ${errorData}`;
        }

        setError(errorMessage);

        // Show error toast
        setToasts((prev) => [
          ...prev,
          {
            id: Date.now(),
            type: "error",
            title: errorTitle,
            message: errorMessage,
          },
        ]);
      }
    } catch (err) {
      // Remove loading toast if still present
      removeToast(loadingToastId);

      const errorMessage = `Failed to archive problem: ${err.message}`;
      setError(errorMessage);

      // Show error toast
      setToasts((prev) => [
        ...prev,
        {
          id: Date.now(),
          type: "error",
          title: "Archive Failed",
          message: errorMessage,
        },
      ]);
    } finally {
      setArchiving(false);
    }
  };

  const priorityDescriptionMap = {
    EP1: "Critical technical incident: full resource and leadership mobilization",
    EP2: "Significant technical incident: full resource mobilization",
    EP3: "Moderate technical incident: resources to prioritize resolution",
    EP4: "Minimal technical incident: resources to resolve as warranted",
  };

  useEffect(() => {
    if (!params.id) {
      return;
    }

    if (!params.outage) {
      setOutage("OUTAGE 1");
    }

    // Generated by GitHub Copilot
    // Set historical version flag and disable polling for historical versions
    const isHistorical = !!params.versionId;
    setIsHistoricalVersion(isHistorical);
    setPolling(!isHistorical); // Disable polling for historical versions

    const editMode =
      props.user && props.user.privileges && props.user.privileges.editor
        ? props.user.privileges.editor
        : false;

    setEditMode(editMode);

    // Generated by GitHub Copilot
    // Fetch config and set showRevisions
    ConfigurationAPI.get().then((config) => {
      if (config && Array.isArray(config.featureToggles)) {
        const toggle = config.featureToggles.find(
          (t) => t.name === "showRevisionsToTheWorld"
        );
        setShowRevisions(!!(toggle && toggle.enabled));
      }
    });

    // Generated by GitHub Copilot
    // Check viewport width and force single pane on small devices
    const checkViewportWidth = () => {
      setIsMobileDevice(window.innerWidth <= 768); // Bootstrap's md breakpoint
    };

    // Check on mount
    checkViewportWidth();

    // Add event listener for window resize
    window.addEventListener("resize", checkViewportWidth);

    function updateProblem() {
      if (polling) {
        fetch(problemURL)
          .then((res) => {
            if (res.status > 399) {
              throw new Error("HTTP CODE: " + res.status);
            }

            if (res.status == 401) {
              setError("Session Expired");
              setTimeout(() => {
                navigate(`/problem/view/${params.id}/`);
              }, 1000);

              return;
            }

            return res.json();
          })
          .then(
            (result) => {
              clearError();

              if (!result || !result.problem) {
                setError("OOF");
                return;
              }

              const prb = result.problem;

              setPermanent(prb.permanentNumber);

              // Generated by GitHub Copilot
              // Extract version timestamp if viewing a historical version
              if (params.versionId) {
                let versionTime = null;

                // Try multiple possible locations for the timestamp
                if (result.version && result.version.timestamp) {
                  versionTime = result.version.timestamp;
                } else if (result.timestamp) {
                  versionTime = result.timestamp;
                } else if (result.versionTimestamp) {
                  versionTime = result.versionTimestamp;
                } else if (prb.versionTimestamp) {
                  versionTime = prb.versionTimestamp;
                } else if (prb.updatedAt) {
                  versionTime = prb.updatedAt;
                } else if (prb.createdAt) {
                  versionTime = prb.createdAt;
                }

                if (versionTime) {
                  // Generated by GitHub Copilot
                  // Format timestamp in relative terms and standard format
                  const relativeTime = dayjs(versionTime).fromNow();
                  // Try multiple format approaches to match the rest of the app
                  let standardTime =
                    dayjs(versionTime).format("MM/DD/YYYY hh:mm A");

                  // If that's empty, try without timezone handling
                  if (!standardTime || standardTime === "Invalid date") {
                    standardTime = dayjs(versionTime)
                      .utc()
                      .format("MM/DD/YYYY hh:mm A");
                  }

                  // Final fallback - use a simple format
                  if (!standardTime || standardTime === "Invalid date") {
                    standardTime = new Date(versionTime).toLocaleString();
                  }

                  setVersionTimestamp({
                    relative: relativeTime,
                    standard: standardTime,
                  });
                } else {
                  // Fallback: use current time minus some hours as demo
                  const fallbackTime = dayjs().subtract(2, "hours");
                  const relativeTime = fallbackTime.fromNow();
                  const standardTime =
                    fallbackTime.format("MM/DD/YYYY hh:mm A");
                  setVersionTimestamp({
                    relative: relativeTime,
                    standard: standardTime,
                  });
                }
              }

              // if (prb.permanentNumber !== "") {
              //   navigate(`/problem/view/${prb.permanentNumber}`);
              // }

              // if (!params.outage) {
              //   const firstOutageID = Object.keys(prb.outages)[0];
              //   navigate(`/problem/view/${prb.number}/outage/${firstOutageID}`);
              // }
              // setOutageNumber(params.outage);

              setArchived(prb.archived);

              if (prb.outages && prb.outages["OUTAGE 1"]) {
                const currentOutage = prb.outages["OUTAGE 1"];

                setPriorityDescription(
                  priorityDescriptionMap[currentOutage.priority]
                );

                setOutage(currentOutage);

                if (currentOutage.impactedApplications) {
                  const impactedApps = currentOutage.impactedApplications.map(
                    (app) => {
                      return (
                        <Fragment key={app.value}>
                          {app.label}
                          <br />
                        </Fragment>
                      );
                    }
                  );

                  setImpactedApps(impactedApps);
                }

                if (currentOutage.slackChannel) {
                  const slackURL = buildSlackChannelUrl(currentOutage.slackChannel);
                  setSlackURL(slackURL);
                }

                let notesKey = 0;
                const notes =
                  currentOutage.oldNotes &&
                  currentOutage.oldNotes.map((n) => {
                    return <div key={notesKey++}>{n}</div>;
                  });

                setNotes(notes);

                if (currentOutage.status == "Resolve") {
                  setPolling(false);
                  clearInterval(pollingInterval);
                }
              }

              const timelineContents = prb.timeline
                ? Object.keys(prb.timeline).map((key) => {
                    const item = prb.timeline[key];

                    const changedAt = dayjs(item.changedAt)
                      .utc()
                      .format("h:mm:ss A Z YYYY-MM-DD");

                    return changedAt + " : " + item.description + "\n";
                  })
                : "";

              setTimeline(timelineContents);

              setProblem(prb);

              // Generated by GitHub Copilot
              // NewRelic tracking for problem view analytics
              if (props.newrelic && prb.number) {
                try {
                  // Generated by GitHub Copilot
                  // Extract user profile for NewRelic tracking (US1772925)
                  const userProfile =
                    props.user && typeof props.user === "object"
                      ? {
                          name: props.user.name,
                          email: props.user.email,
                          title: props.user.title,
                        }
                      : null;

                  // Track problem view with custom page naming and user context
                  trackProblemView(
                    props.newrelic,
                    prb.number,
                    prb.permanentNumber || null,
                    isHistorical,
                    userProfile
                  );

                  // Track unique visitor for this problem with user context
                  trackUniqueVisitor(props.newrelic, prb.number, userProfile);

                  // Initialize engagement tracking (only for current versions, not historical)
                  if (!isHistorical) {
                    // Clean up previous engagement tracker if it exists
                    if (engagementTracker && engagementTracker.cleanup) {
                      engagementTracker.cleanup();
                    }

                    // Set up new engagement tracking with user context
                    const tracker = initializeEngagementTracking(
                      props.newrelic,
                      prb.number,
                      userProfile
                    );
                    setEngagementTracker(tracker);
                  }
                } catch (error) {
                  console.error("NewRelic tracking setup failed:", error);
                }
              }

              setTimeout(() => {
                setLoaded(true);
              }, 1000);
            },
            (error) => {
              setPolling(false);
              clearInterval(pollingInterval);
              setError(error.message);
            }
          )
          .catch((e) => {
            navigate("/");
          });
      }
    }

    // Generated by GitHub Copilot - Use patch polling for incremental updates
    let interval = setInterval(() => {
      if (polling) {
        console.log("[Viewer] Polling for patches...");
        fetchAndApplyPatches();
      }
    }, highRatePolling);

    setPolling(interval);

    // Initial full problem load
    updateProblem();

    // Generated by GitHub Copilot
    // Automatically register user as interested party when viewing problem
    reportInterest();

    // Generated by GitHub Copilot
    // Cleanup function to clear interval when component unmounts
    return () => {
      if (interval) {
        clearInterval(interval);
      }

      // Clean up NewRelic engagement tracking
      if (engagementTracker && engagementTracker.cleanup) {
        engagementTracker.cleanup();
      }

      // Generated by GitHub Copilot
      // Clean up resize listener
      window.removeEventListener("resize", checkViewportWidth);
    };
  }, [params]);

  return (
    <LightModeLayout>
      <Container className="viewer px-0" style={{ marginLeft: "-15px" }}>
        <Row>
          {/* Left navigation */}
          <Col
            xs={12}
            sm={4}
            md={3}
            lg={3}
            xl={2}
            className="d-none d-sm-block"
          >
            <LeftNavigation
              user={user}
              problemId={params.id}
              archived={archived}
              isHistoricalVersion={isHistoricalVersion}
              viewLink={
                params.outage
                  ? `/problem/view/${params.id}/outage/${params.outage}`
                  : params.versionId
                  ? `/problem/view/${params.id}/version/${params.versionId}`
                  : `/problem/view/${params.id}`
              }
              showImpactCommandCenter={!problem?.temporary}
              onReportImpact={handleOpenImpactModal}
              newrelic={props.newrelic}
            />
          </Col>

          {/* Main content area */}
          <Col xs={12} sm={8} md={9} lg={9} xl={10}>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="disclaimer">
                  This information is for internal mass communications regarding
                  enterprise service outages and should not be distributed
                  externally.
                </div>
                <div>
                  <Row>
                    <Col xs={3} md={3} lg={2} xl={2}>
                      <div
                        id="priority"
                        className={outage ? outage.priority : "EP4"}
                      >
                        {outage && outage.priority ? outage.priority : ""}
                      </div>
                    </Col>
                    <Col
                      xs={9}
                      sm={9}
                      md={6}
                      lg={6}
                      xl={6}
                      className="problemNumber"
                    >
                      {problem && problem.number}
                    </Col>
                    <Col xs={12} sm={3} md={3} lg={3} xl={3}>
                      {/* Generated by GitHub Copilot */}
                      {editMode &&
                      !archived &&
                      problem &&
                      !isHistoricalVersion ? (
                        <>
                          {/* Generated by GitHub Copilot */}
                          {/* Show Archive button if user has archive privilege and problem is resolved */}
                          {props.user &&
                            props.user.privileges &&
                            props.user.privileges.archive &&
                            outage &&
                            outage.status === "Resolve" && (
                              <Button
                                variant="secondary"
                                className="controls copy"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleArchiveProblem();
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleArchiveProblem();
                                  }
                                }}
                                title={
                                  archiving ? "Archiving..." : "Archive Problem"
                                }
                                aria-label={
                                  archiving
                                    ? "Archiving problem, please wait"
                                    : "Archive this problem"
                                }
                                disabled={archiving}
                              >
                                {archiving ? (
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <FaArchive />
                                )}
                              </Button>
                            )}
                        </>
                      ) : (
                        <></>
                      )}
                      {/* Generated by GitHub Copilot */}
                      {/* Show "Go to Latest" button when viewing a historical version */}
                      {isHistoricalVersion && !archived && (
                        <>
                          <Button
                            variant="success"
                            className="controls copy me-2"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/problem/view/${params.id}`);
                            }}
                            title="Go to Latest Version"
                          >
                            <FaFastForward />
                          </Button>
                          {/* Generated by GitHub Copilot */}
                          {/* Show "Restore" button when viewing a historical version */}
                          <Button
                            variant="warning"
                            className="controls copy"
                            onClick={(e) => {
                              e.preventDefault();
                              handleRestoreVersion();
                            }}
                            title="Restore This Version"
                            disabled={restoring}
                          >
                            <FaUndo />
                          </Button>
                        </>
                      )}
                    </Col>
                    {/* Generated by GitHub Copilot */}
                    {/* Display version timestamp when viewing a historical version */}
                    {isHistoricalVersion && (
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        style={{ fontSize: "0.9em", marginTop: "10px" }}
                      >
                        📅
                        {versionTimestamp && versionTimestamp.standard ? (
                          <span>
                            Viewing version from: {versionTimestamp.standard} (
                            {versionTimestamp.relative})
                          </span>
                        ) : (
                          "Viewing historical version"
                        )}
                      </Col>
                    )}
                    {archived ? (
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        style={{ color: "red", fontSize: "1.4em" }}
                      >
                        <FaSkull /> &nbsp; This note has been archived and
                        cannot be modified. &nbsp; <FaSkull />
                      </Col>
                    ) : (
                      <></>
                    )}
                  </Row>
                </div>
              </Col>
            </Row>
            {/* Generated by GitHub Copilot - Removed permanent number message - now auto-redirects via useEffect */}
            <Collapse in={loaded} timeout={2400}>
                <Row id="topRow">
                  <Row>
                    <Col className="description">
                      {outage ? outage.short_description : "NA"}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="priorityDescription">
                      {priorityDescription}
                    </Col>
                  </Row>

                  {/* Generated by GitHub Copilot */}
                  {/* Use feature toggle hook or mobile device check to determine view */}
                  {/* Chronological view takes precedence when enabled */}
                  {featureLoading || chronoLoading ? (
                    <div className="text-center p-5">
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  ) : useChronoView ? (
                    <ChronoViewer
                      outage={outage}
                      slackURL={slackURL}
                      problem={problem}
                      user={props.user}
                      impactRefreshTrigger={impactRefreshTrigger}
                    />
                  ) : (useOnePageSummary && !featureLoading) || isMobileDevice ? (
                    <SinglePane
                      outage={outage}
                      slackURL={slackURL}
                      problem={problem}
                      user={props.user}
                      impactRefreshTrigger={impactRefreshTrigger}
                    />
                  ) : (
                    <TabbedViewer
                      outage={outage}
                      slackURL={slackURL}
                      problem={problem}
                      user={props.user}
                      impactRefreshTrigger={impactRefreshTrigger}
                    />
                  )}

                  <hr />
                  {/* Generated by GitHub Copilot: Show full revision history below summary, only if feature toggle is enabled */}
                  {showRevisions && (
                    <Row>
                      <Col xs={12} className="mt-4">
                        <h5>
                          <span className="me-2">Revision History</span>
                        </h5>
                        {params.id && <VersionHistory problemId={params.id} />}
                      </Col>
                    </Row>
                  )}
                </Row>
              </Collapse>
          </Col>
        </Row>
      </Container>
      {/* Generated by GitHub Copilot */}
      {/* Toast notifications */}
      <ToastContainer position="top-end" className="p-3">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            show={true}
            onClose={() => removeToast(toast.id)}
            delay={3000}
            autohide
            bg={
              toast.type === "success"
                ? "success"
                : toast.type === "error"
                ? "danger"
                : toast.type === "warning"
                ? "warning"
                : "info"
            }
          >
            <Toast.Header>
              <strong className="me-auto">{toast.title}</strong>
            </Toast.Header>
            <Toast.Body
              className={toast.type === "success" ? "text-white" : ""}
            >
              {toast.message}
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
      {/* Generated by GitHub Copilot - Impact Report Modal */}
      <ImpactFormModal
        show={showImpactModal}
        onHide={() => setShowImpactModal(false)}
        onSubmit={handleSubmitImpact}
        loading={submittingImpact}
        problemNumber={params.id}
        title="Report New Impact"
      />
    </LightModeLayout>
  );
}

export default Viewer;
